<template>
  <div class="flex flex-col h-screen bg-page">
    <div class="flex-1 overflow-hidden overflow-y-scroll">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="px-10 pt-10">
            <div
              v-for="item in list"
              :key="item.id"
              class="list-item"
              @click="$router.push({ name: 'noticeDetail', query: { id: item.id } })"
            >
              <div class="flex items-center relative">
                <div class="bg-yellow text-12 rounded-2 leading-16 px-2 text-white mr-4" v-if="item.is_index == 2">
                  顶
                </div>
                <ListTitle :name="item.title" />
                <div v-if="item.read_type == 1" class="bg-orange w-6 h-6 rounded-full" style="margin-top: -12px;"></div>
              </div>
              <div class="text-14 text-999 mt-5 leading-16">{{ item.time_name }}</div>
              <div class="text-14 text-gray line-clamp-2 mt-5 leading-22">{{ item.summary }}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script setup>
import { reactive, ref, computed } from "vue";
import { noticeService } from "@/service";
import to from "await-to-js";
import { useStore } from "@/store";

const store = useStore();
const userInfo = computed(() => store.state.userInfo);

// 搜索表单数据
const formData = reactive({
  send_uid: userInfo.value.id || "",
  announcement_state: 1,
  page: 1,
  pagesize: 20
});

const list = ref([]);
const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);

const onLoad = async () => {
  if (refreshing.value) {
    list.value = [];
    formData.page = 1;
    refreshing.value = false;
  }
  const [error, data] = await to(noticeService.announcement_lists(formData));
  if (error) {
    list.value = [];
    finished.value = true;
    return;
  }
  loading.value = false;
  list.value.push(...data.data.data);
  formData.page++;
  if (list.value.length >= data.data.total) {
    finished.value = true;
  }
};
const onRefresh = () => {
  refreshing.value = true;
  finished.value = false;
  loading.value = true;
  onLoad();
};
</script>
